import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fd52196"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-box" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "form-main" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "绑定情况如下，可以拖动设备调整线路", -1))
const _hoisted_5 = { class: "form-body" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "绑定情况", -1))
const _hoisted_8 = { class: "children" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"color":"red"}
}, " 待绑定设备 ", -1))
const _hoisted_11 = { class: "form-btn-group" }

import { inject, onMounted, ref } from 'vue';
import { request } from '@/util/request';
import { WindowTool } from '@/components/common/window/WindowInterface';
import ScTree from '@/components/common/tree/ScTree.vue';
import TranReduce from '@/components/common/transition/TranReduce.vue';
import { DataNode } from '@/components/common/tree/TreeUtil';
import DeviceNode from './DeviceNode.vue';
import ProxyNode from './ProxyNode.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BindDevice',
  props: {
    proxies: {},
    devices: {},
    num: {}
  },
  setup(__props: any) {

const props = __props;
const remainingDevices = ref<any[]>([]);

const windowTool = inject<WindowTool | false>(WindowTool, false);

const tree = ref<InstanceType<typeof ScTree>>();
onMounted(() => {
  const perNum = Number(props.num);
  let currentIndex = 0;
  const data = props.proxies.map((proxy) => {
    const devices = props.devices.slice(currentIndex, currentIndex + perNum);
    currentIndex += perNum;
    return {
      id: proxy.id,
      data: proxy,
      opened: true,
      children: devices.map((device) => {
        return {
          id: device.id,
          data: device,
          children: [],
        };
      }),
    };
  });
  remainingDevices.value = props.devices.slice(currentIndex);
  tree.value.setData({
    id: 1,
    opened: true,
    data: {
      name: 'AlignLeftOutlined',
    },
    children: data,
  });
});

function remove( node: DataNode<any>) {
  remainingDevices.value.push(node.data);
  node.del();
}

function onDrag(
  ev: { data: { id: string }; source: string },
  target: DataNode<unknown>,
  pos: 'before' | 'after' | 'inside'
) {
  if (ev.data.id === target.id) {
    return;
  }
  if (tree.value) {
    console.log(ev, target);
    if (ev.source === 'remaining') {
      tree.value.getRoot().addChild({
        id: ev.data.id,
        data: ev.data,
      });
      remainingDevices.value.splice(
        remainingDevices.value.findIndex((i) => i.id === ev.data.id),
        1
      );
    }
    tree.value.moveNodeTo(ev.data.id, target.id, pos);
    if (pos === 'inside') {
      target.setOpen(true);
    } else if (target.parent) {
      target.parent.setOpen(true);
    }
  }
}

function close() {
  if (windowTool) {
    windowTool.close(true);
  }
}

async function submit() {
  if (!tree.value) {
    return;
  }
  const data = tree.value?.getRoot()?.children.map((i) => {
    return {
      id: i.id,
      devices: i.children.map((i) => i.id),
    };
  });
  const res = await request('management/proxy/bind', { data });
  if (res) {
    close();
  }
}

const columns = [
  {
    title: '代理信息',
    dataIndex: 'data',
    key: 'data',
  },
  {
    title: '结果',
    dataIndex: 'err',
    key: 'err',
  },
];

return (_ctx: any,_cache: any) => {
  const _component_sc_btn = _resolveComponent("sc-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(ScTree, {
              ref_key: "tree",
              ref: tree
            }, {
              default: _withCtx(({ node, children }) => [
                (node.level === 1)
                  ? (_openBlock(), _createBlock(ProxyNode, {
                      key: 0,
                      node: node,
                      onMove: _cache[0] || (_cache[0] = ($event: any) => (onDrag(...$event)))
                    }, null, 8, ["node"]))
                  : _createCommentVNode("", true),
                (node.level === 2)
                  ? (_openBlock(), _createBlock(DeviceNode, {
                      key: 1,
                      level: node.level,
                      remove: () => remove(node),
                      source: "tree",
                      data: node.data
                    }, null, 8, ["level", "remove", "data"]))
                  : _createCommentVNode("", true),
                _createVNode(TranReduce, {
                  show: node.opened
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children, (child, index) => {
                        return (_openBlock(), _createBlock(_resolveDynamicComponent(child), { key: index }))
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, 1032, ["show"])
              ]),
              _: 1
            }, 512)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(remainingDevices.value, (device, k) => {
              return (_openBlock(), _createBlock(DeviceNode, {
                level: 0,
                source: "remaining",
                data: device,
                key: k
              }, null, 8, ["data"]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_sc_btn, {
          type: "primary",
          handler: submit,
          text: "绑定"
        })
      ])
    ])
  ]))
}
}

})